import { createFileRoute, redirect } from '@tanstack/react-router';

import { SignIn } from '#modules/user/features/auth/components/SignIn';
import { appendNewUserFlag } from '#modules/user/features/onboarding/utils/appendNewUserFlag';
import { isNewUserFlag } from '#modules/user/features/onboarding/utils/isNewUserFlag';

export const Route = createFileRoute('/{-$locale}/_layout/sign-in')({
  // data-only: beforeLoad (проверка «уже вошёл» и редирект) идёт на сервере, форма рисуется только
  // в браузере. При ssr: false редирект шёл на клиенте до первой отрисовки: после возврата из
  // Google /sign-in менялся на /dashboard прямо при гидратации, и React падал с ошибкой #418.
  ssr: 'data-only',
  validateSearch: (
    search: Record<string, unknown>
  ): { redirect?: string; provider?: string; msg?: string; newUser?: string | boolean } => ({
    // redirect: post-login return target (set by the _authed guard). provider/msg are existing
    // OAuth params (spinner + error toast) — keep them or validateSearch would strip them from the URL.
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
    provider: typeof search.provider === 'string' ? search.provider : undefined,
    msg: typeof search.msg === 'string' ? search.msg : undefined,
    // newUser: возврат из OAuth для только что заведённого аккаунта. Приходит строкой при
    // навигации внутри приложения и boolean при разборе самого адреса — обе формы обязаны выжить,
    // иначе метка теряется ровно здесь и новичок не видит онбординг вообще.
    newUser:
      typeof search.newUser === 'string' || typeof search.newUser === 'boolean'
        ? search.newUser
        : undefined,
  }),
  beforeLoad: async ({ context, location }) => {
    if (context.isAuth) {
      const search = location.search as { redirect?: string; newUser?: string | boolean };
      const target = search.redirect ?? '/dashboard';

      // Метку новичка передаём дальше по цепочке: вход через провайдера часто начинается с этой
      // страницы, и без переноса флага он умирал на редиректе вместе с онбордингом.
      if (isNewUserFlag(search.newUser)) {
        throw redirect({ href: appendNewUserFlag(target) });
      }

      throw redirect({ to: target });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <SignIn />;
}
